import { IConfig } from '@cian/config/shared';
import { getTermValue, TJsonQuery } from 'shared/common/packages/JsonQuery';
import { EBuildingStatus } from 'shared/common/packages/api-models/common/json_query';

const SPECIAL_ZOOM_MIN = 15;
const SPECIAL_ZOOM_MAX = 16;

interface IHasZoomGroupChangedParams {
  currentZoom: number;
  previousZoom: number | undefined;
  config: IConfig;
  jsonQuery: TJsonQuery;
}

/**
 * Проверяет, изменилась ли группа зумов (переход между особыми зумами 15-16 и остальными)
 * @param params - Параметры для проверки
 * @returns true, если произошел переход между группами зумов
 */
export function hasZoomGroupChanged(params: IHasZoomGroupChangedParams): boolean {
  const { currentZoom, previousZoom, config, jsonQuery } = params;

  const isEnabled = config.get<boolean>('Newbuilding.NewbuildingPin.Enabled');

  if (!isEnabled) {
    return false;
  }

  const isFlatSearch = jsonQuery._type === 'flatsale';
  if (!isFlatSearch) {
    return false;
  }

  const buildingStatus = getTermValue('building_status')(jsonQuery);
  const isSecondaryOnly = buildingStatus === EBuildingStatus.Old;

  if (isSecondaryOnly) {
    return false;
  }

  if (previousZoom === undefined) {
    return false;
  }

  const currentIsSpecial = isSpecialZoom(currentZoom);
  const previousIsSpecial = isSpecialZoom(previousZoom);

  return currentIsSpecial !== previousIsSpecial;
}

function isSpecialZoom(zoom: number): boolean {
  return zoom >= SPECIAL_ZOOM_MIN && zoom <= SPECIAL_ZOOM_MAX;
}
